import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/9nteHJnxW5SjRzg9LFA2S8/Screenshot_2026-03-30_121430-removebg-preview.png';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const showSolidBg = isScrolled || !isHomePage;
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Who We Are',
    href: '/who-we-are'
  }, {
    name: 'Practice Areas',
    href: '/practice-areas'
  }, {
    name: 'Regional Focus',
    href: '/regional-focus'
  }, {
    name: 'Insights',
    href: '/insights'
  }];
  return <>
      <motion.header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-sm" animate={{
      backgroundColor: showSolidBg ? 'rgba(0, 33, 71, 1)' : 'rgba(0, 33, 71, 0)',
      borderBottomColor: showSolidBg ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.05)'
    }} transition={{
      duration: 0.3
    }} style={{
      borderBottomWidth: 1,
      borderBottomStyle: 'solid'
    }} data-id="element-58">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
          <div className="flex justify-between items-center h-20 lg:h-24" data-id="element-60">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0 cursor-pointer" data-id="element-61">
              <img src={LOGO_URL} alt="Emmakay Global Consultants" className="h-12 lg:h-14 w-auto object-contain bg-white rounded px-2.5 py-1.5" data-id="element-62" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-63">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`font-sans text-[13px] font-semibold uppercase tracking-wider transition-colors ${location.pathname === link.href ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-64">
                  {link.name}
                </Link>)}
              <Link to="/inquiry" className="bg-gold hover:bg-gold-light text-navy font-sans font-bold text-[13px] uppercase tracking-wider px-5 py-2.5 rounded-card transition-colors shadow-sm" data-id="element-65">
                Market Access Inquiry
              </Link>
            </nav>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center" data-id="element-66">
              <button onClick={() => setIsMobileMenuOpen(true)} className="text-white hover:text-gold transition-colors p-2" aria-label="Open menu" data-id="element-67">
                <MenuIcon className="h-6 w-6" data-id="element-68" />
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-69">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[60] bg-navy flex flex-col" data-id="element-70">
            <div className="flex justify-between items-center h-20 px-4 sm:px-6" data-id="element-71">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="flex-shrink-0" data-id="element-72">
                <img src={LOGO_URL} alt="Emmakay Global Consultants" className="h-12 w-auto object-contain bg-white rounded px-2.5 py-1.5" data-id="element-73" />
              </Link>
              <button onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-gold p-2" aria-label="Close menu" data-id="element-74">
                <XIcon className="h-7 w-7" data-id="element-75" />
              </button>
            </div>
            <div className="flex-1 flex flex-col justify-center items-center space-y-7 px-4" data-id="element-76">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`font-serif text-2xl transition-colors ${location.pathname === link.href ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-77">
                  {link.name}
                </Link>)}
              <Link to="/inquiry" className="mt-6 bg-gold text-navy font-sans font-bold text-sm uppercase tracking-wide px-8 py-4 rounded-card w-full max-w-xs text-center" data-id="element-78">
                Market Access Inquiry
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}